// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_upload-module__button--2tmti{margin-bottom:15px}\n", ""]);
// Exports
exports.locals = {
	"button": "lawyer_upload-module__button--2tmti"
};
module.exports = exports;
